import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import BlogSingle from "../../components/BlogDetails/BlogSingle";
import blogs from "../../api/blogs";

const BlogDetails: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  // ✅ Get current blog safely
  const currentBlog = blogs.find((item) => item.slug === slug);

  return (
    <Fragment>
      <Navbar hclass="wpo-header-style-1" />
      <PageTitle
        pageTitle={currentBlog ? currentBlog.title : "Blog Not Found"}
        pagesub="Blog"
      />

      {/* ✅ Pass blog data to BlogSingle */}
      <BlogSingle blog={currentBlog} />

      <Footer footerClass="wpo-site-footer-s1" />
      <Scrollbar />
    </Fragment>
  );
};

export default BlogDetails;
